const licenses = {
    "CC-BY-4.0": {
        "title": {
            "en": "Creative Commons Attribution 4.0 Attribution",
        },
        "url": "https://creativecommons.org/licenses/by/4.0",
        "code": "CC-BY-4.0",
    },
    "CC-BY-SA-4.0": {
        "title": {
            "en": "Creative Commons Attribution 4.0 Attribution-ShareAlike",
        },
        "url": "https://creativecommons.org/licenses/by-sa/4.0/",
        "code": "CC-BY-SA-4.0",
    },
    "CC-BY-ND-4.0": {
        "title": {
            "en": "Creative Commons Attribution 4.0 Attribution-NoDerivs",
        },
        "url": "https://creativecommons.org/licenses/by-nd/4.0/",
        "code": "CC-BY-ND-4.0",
    },
    "CC-BY-NC-4.0": {
        "title": {
            "en": "Creative Commons Attribution 4.0 Attribution-NonCommercial",
        },
        "url": "https://creativecommons.org/licenses/by-nc/4.0/",
        "code": "CC-BY-NC-4.0",
    },
    "CC-BY-NC-SA-4.0": {
        "title": {
            "en": "Creative Commons Attribution 4.0 Attribution-NonCommercial-ShareAlike",
        },
        "url": "https://creativecommons.org/licenses/by-nc-sa/4.0/",
        "code": "CC-BY-NC-SA-4.0",
    },
    "CC-BY-NC-ND-4.0": {
        "title": {
            "en": "Creative Commons Attribution 4.0 Attribution-NonCommercial-NoDerivs",
        },
        "url": "https://creativecommons.org/licenses/by-nc-nd/4.0/",
        "code": "CC-BY-NC-ND-4.0",
    },
    "CC0": {
        "title": {
            "en": "Creative Commons 0",
        },
        "url": "https://creativecommons.org/share-your-work/public-domain/cc0",
        "code": "CC0",
    },
    "government-open-license-canada": {
        "title": {
            "en": "Open Government Licence - Canada",
            "fr": "Licence du gouvernement ouvert – Canada ",
        },
        "url": "https://open.canada.ca/en/open-government-licence-canada",
        "code": "government-open-license-canada",
    },
    "government-open-license-nova-scotia": {
        "title": {
            "en": "Open Government Licence - Nova Scotia",
        },
        "url": "https://novascotia.ca/opendata/licence.asp",
        "code": "government-open-license-nova-scotia",
    },
    "OGL-NB": {
        "title": {
            "en": "Open Government Licence – New Brunswick",
        },
        "url": "http://www.snb.ca/e/2000/data-E.html",
        "code": "OGL-NB",
    },
    "OGL-BC": {
        "title": {
            "en": "Open Government Licence - British Columbia",
        },
        "url": "https://www2.gov.bc.ca/gov/content/data/open-data/open-government-licence-bc",
        "code": "OGL-BC",
    },
    "government-open-license-newfoundland": {
        "title": {
            "en": "Open Government Licence - Newfoundland and Labrador",
        },
        "url": "https://opendata.gov.nl.ca/public/opendata/page/?page-id=licence",
        "code": "government-open-license-newfoundland",
    },
    "Apache-2.0": {
        "title": {
            "en": "Apache License, Version 2.0",
        },
        "url": "https://www.apache.org/licenses/LICENSE-2.0",
        "code": "Apache-2.0",
    },
    "None": {
        "title": {
            "en": "No License",
            "fr": "Aucune licence",
        },
        "url": "https://choosealicense.com/no-permission/",
        "code": "None",
    },
    "ca-eccc-odl": {
        "title": {
            "en": "Environment and Climate Change Canada Data Servers End-use Licence",
            "fr": "Licence d’utilisation finale pour les serveurs de données d’Environnement et Changement climatique Canada",
        },
        "url": "https://eccc-msc.github.io/open-data/licence/readme_en/",
        "code": "ca-eccc-odl",
    },
};

export default licenses;
